import BaseService from '../BaseService'
import ApplicationException from '../ApplicationException'
import EformSubmitStatus from '../components/SubmitStatus/EformSubmitStatus'

export default class EformBaseService extends BaseService {

  constructor(relativeBase) {
    super(relativeBase)
  }

  async create(object, commandSuffix = '') {
    // don't use create method to submit forms. use submit instead.
    return null
  }

  async submit(object, form, formComponent = null, commandSuffix = '') {
    send(EformSubmitStatus.EVENT.LOADING, {}, form)
    await this.retrieveBackendUrl()

    // Generate a fresh captcha token right before submitting (turnstile has 5 min TTL tokens)
    const captchaToken = formComponent?.getNewToken ? await formComponent.getNewToken() : null

    return this.checkStatus(form,
      fetch(this.backendUrl + commandSuffix, {
        method: 'POST',
        cache: 'reload',
        headers: this.getJsonHeader(captchaToken),
        body: JSON.stringify(object)
      })
    )
  }

  async checkStatus(form, promise) {
    this.configUtil.updateToken()
    return promise
      .then(async result => {
        if (result.ok) {
          const contentType = result.headers.get('content-type')
          if (contentType && contentType.indexOf('application/json') !== -1) {
            const json = await result.json()
            const successPayload = {
              formName: json.formName,
              formUuid: json.uuid,
              timestamp: json.timestamp,
              email: json.email
            }
            send(EformSubmitStatus.EVENT.SUCCESS, successPayload)
            return json
          } else {
            send(EformSubmitStatus.EVENT.ERROR, {}, form)
            throw new ApplicationException() // only json response is expected
          }
        } else {
          const json = await result.json()
          const errorPayload = {
            title: json.title,
            detail: json.detail,
            reasons: json.reasons
          }
          send(EformSubmitStatus.EVENT.ERROR, errorPayload, form)
          throw new ApplicationException()
        }
      })
      .catch(error => {
        if (error instanceof ApplicationException) {
          throw error
        } else {
          send(EformSubmitStatus.EVENT.ERROR, {}, form)
          this.logging.log(error)
        }
      })
  }

}
